(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Comercio', Comercio);

    Comercio.$inject = ['$resource'];

    function Comercio ($resource) {
        var resourceUrl =  'api/comercios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
